import './index.css'
import * as React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import type { State } from 'types/redux'
type Option = {
  value: string
  label: string
}

function mapStateToProps(state: State): any {
  return {
    lists: state.emailGroups.emailGroups.map(g => ({
      value: g.id.toString(),
      label: g.name,
    })),
  }
}

class SelectList extends React.Component<{
  lists: Array<Option>
  value: string | null | undefined
  clearable: boolean
  className?: string
  onChange: (value: string) => unknown
}> {
  static defaultProps = {
    className: 'SelectList',
  }

  render() {
    return (
      <Select
        simpleValue
        clearable={this.props.clearable}
        className={this.props.className}
        placeholder="Select list"
        options={this.props.lists}
        value={this.props.value}
        onChange={this.props.onChange}
      />
    )
  }
}

export default connect(mapStateToProps)(SelectList) as any
